import React from 'react';
import { Formik, Form, Field } from 'formik';
import { useTheme } from 'styled-components';

import { useConfig } from 'Context/ConfigContext';
import { useQuizContext } from 'Context/QuizContext';
import { secondsToTime } from 'Util/datetime';

import { QUIZ_VARIANTS } from '../../constant';
import { useAssessmentContext, SESSION_STATUS } from '../../../../Context/AssessmentContext';

// This component is built from formik <Field /> component
const Choice = ({ id, name, label, value, as, ...restProps }) => {
  const { colors } = useTheme();
  return (
    <Field
      id={id}
      name={name}
      type={'radio'}
      label={label}
      value={value}
      as={as}
      color={colors.primary}
      {...restProps}
    />
  );
};

const QuizBoxContainer = ({ children }) => {
  const {
    classroom: { quiz },
  } = useConfig();
  const { showAnswersConfirmation = false } = quiz?.gradedExam ?? {};
  const {
    currentQuestionIndex,
    currentQuestion,
    metaData,
    goToNextQuestion,
    goToPreviousQuestion,
    submitAnswer,
    setStatus,
    status,
    timeRemaining: secondsRemaining,
    setRequestSubmitGradedExam,
  } = useAssessmentContext();
  const { variant } = useQuizContext();
  const timeRemaining = secondsToTime(secondsRemaining);
  const { totalQuestions } = metaData || {};
  const {
    id: questionId,
    content: question,
    selectedAnswer,
    choices,
    precisionNumber,
    type,
    passage,
  } = currentQuestion;
  const isLastQuestion = currentQuestionIndex === totalQuestions - 1;
  const isFirstQuestion = currentQuestionIndex === 0;
  const currentQuestionText = `คำถามที่ ${currentQuestionIndex + 1} จาก ${totalQuestions}`;

  return (
    <Formik
      enableReinitialize={true}
      initialValues={{
        [questionId]: selectedAnswer ? selectedAnswer : '',
      }}
      onSubmit={async (values, actions) => {
        // FIXME: Must always call submitAnswer!!!
        // This is a workaround to fix https://skooldio.atlassian.net/browse/ANY-439
        //
        // if (values[questionId] !== selectedAnswer) {
        //   await submitAnswer(currentQuestion, values[questionId]);
        // }
        await submitAnswer(currentQuestion, values[questionId]);
      }}
      render={(props) => {
        const { submitForm, isSubmitting } = props;
        return (
          <Form style={{ height: '100%' }}>
            {children({
              onNext: async () => {
                await submitForm();
                if (isLastQuestion) {
                  if (variant === QUIZ_VARIANTS.GRADED_EXAM && !showAnswersConfirmation) {
                    setRequestSubmitGradedExam(true);
                  } else {
                    setStatus(SESSION_STATUS.CONFIRMING_ANSWER);
                  }
                } else {
                  goToNextQuestion();
                }
              },
              onBack: async () => {
                await submitForm();
                goToPreviousQuestion();
              },
              question: question,
              questionId: questionId,
              questionType: type,
              choices: choices,
              precisionNumber: precisionNumber,
              isLastQuestion,
              isFirstQuestion,
              isSubmitting,
              status,
              timeRemaining,
              variant,
              currentQuestionText,
              passage,
            })}
          </Form>
        );
      }}
    />
  );
};

export { Choice, QuizBoxContainer };
export default QuizBoxContainer;
